(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offers-popup"] && !Shopify.designMode) return;
  try {
    

  (() => {

    /*
      Shopify loads this once,
      including when the section starts disabled.
    */

    if (
      customElements.get(
        'zad-offers-popup'
      )
    ) return;


    const shownOnPage =
      new Set();


    const editorPreview =
      new Map();



    customElements.define(

      'zad-offers-popup',

      class extends HTMLElement {

        connectedCallback() {

          if (this.controller) return;


          this.controller =
            new AbortController();


          this.frame =
            requestAnimationFrame(
              () => this.initialize()
            );

        }



        initialize() {

          this.dialog =
            this.querySelector(
              'dialog'
            );


          if (
            !this.dialog
            ||
            typeof this.dialog.showModal
            !== 'function'
          ) return;



          this.closeButton =
            this.querySelector(
              '.offers-popup__close'
            );


          this.editor =
            Boolean(
              window.Shopify
              &&
              window.Shopify.designMode
            );


          this.storageKey =
            'offers-popup-'
            +
            this.dataset.sectionId;


          this.editorKey =
            'theme-editor-dismissed-'
            +
            this.storageKey;


          this.cookieKey =
            encodeURIComponent(
              this.storageKey
            );


          const delay =
            Number(
              this.dataset.delay
            );


          this.delay =
            Number.isFinite(delay)
            &&
            delay >= 0

              ? delay

              : 3000;


          const options = {
            signal:
              this.controller.signal
          };



          this.closeButton.addEventListener(

            'click',

            () =>
              this.closePopup(),

            options

          );



          this.dialog.addEventListener(

            'click',

            (event) => {

              if (
                event.target.classList.contains(
                  'offers-popup__overlay'
                )
                ||
                event.target === this.dialog
              ) {

                this.closePopup();

              }



              /*
                Dismiss for same-page
                shopping links as well
                as normal navigation.
              */

              if (
                event.target.closest(
                  'a[href]'
                )
                &&
                !event.ctrlKey
                &&
                !event.metaKey
                &&
                !event.shiftKey
                &&
                !event.altKey
              ) {

                this.closePopup();

              }

            },

            options

          );



          this.dialog.addEventListener(

            'cancel',

            (event) => {

              event.preventDefault();

              this.closePopup();

            },

            options

          );



          this.dialog.addEventListener(

            'close',

            () => {

              if (!this.dialog.open) {
                this.closePopup();
              }

            },

            options

          );



          this.dialog.addEventListener(

            'keydown',

            (event) =>
              this.trapFocus(event),

            options

          );



          window.addEventListener(

            'pagehide',

            () =>
              this.closePopup(false),

            options

          );



          window.addEventListener(

            'pageshow',

            (event) => {

              if (event.persisted) {
                this.schedule();
              }

            },

            options

          );



          if (this.editor) {

            const matches =
              (event) =>
                String(
                  event.detail?.sectionId
                )
                ===
                this.dataset.sectionId;



            document.addEventListener(

              'shopify:section:select',

              (event) => {

                if (
                  matches(event)
                  &&
                  !event.detail.load
                ) {

                  this.openPopup(true);

                }

              },

              options

            );



            document.addEventListener(

              'shopify:block:select',

              (event) => {

                if (
                  !matches(event)
                  ||
                  event.detail.load
                ) return;


                this.openPopup(true);


                const block =
                  Array.from(
                    this.querySelectorAll(
                      '[data-offer-id]'
                    )
                  )
                  .find(
                    (item) =>
                      item.dataset.offerId
                      ===
                      String(
                        event.detail.blockId
                      )
                  );


                if (block) {

                  block.scrollIntoView({
                    block: 'nearest',
                    behavior: 'instant'
                  });

                }

              },

              options

            );



            document.addEventListener(

              'shopify:section:deselect',

              (event) => {

                if (matches(event)) {
                  this.closePopup();
                }

              },

              options

            );



            document.addEventListener(

              'shopify:section:unload',

              (event) => {

                if (matches(event)) {
                  this.disconnectedCallback();
                }

              },

              options

            );

          }



          this.schedule();

        }



        readCookie() {

          try {

            const prefix =
              this.cookieKey + '=';


            const cookie =
              document.cookie
              .split('; ')
              .find(
                (item) =>
                  item.startsWith(prefix)
              );


            return cookie
              ?
              cookie.slice(
                prefix.length
              )
              :
              null;

          }

          catch (_) {

            return null;

          }

        }



        shouldShow() {

          if (this.editor) {

            if (
              editorPreview.has(
                this.storageKey
              )
            ) {

              return editorPreview.get(
                this.storageKey
              );

            }



            /*
              Editor-only,
              tab-scoped dismissal.
            */

            try {

              return (
                sessionStorage.getItem(
                  this.editorKey
                )
                !==
                'true'
              );

            }

            catch (_) {

              return true;

            }

          }



          /*
            Survives AJAX section
            replacements even when
            browser storage is blocked.
          */

          if (
            shownOnPage.has(
              this.storageKey
            )
          ) {

            return false;

          }



          const cookie =
            this.readCookie();



          if (
            this.dataset.frequency
            ===
            'session'
          ) {

            if (
              cookie === 'session'
            ) {

              return false;

            }


            try {

              return (
                !sessionStorage.getItem(
                  this.storageKey
                )
              );

            }

            catch (_) {

              return true;

            }

          }



          if (
            this.dataset.frequency
            ===
            'daily'
          ) {

            let saved =
              cookie;


            try {

              saved =
                localStorage.getItem(
                  this.storageKey
                )
                ||
                saved;

            }

            catch (_) {

              /* Use cookie fallback */

            }



            const timestamp =
              Number(saved);


            const elapsed =
              Date.now()
              -
              timestamp;



            return (
              !timestamp
              ||
              !Number.isFinite(
                timestamp
              )
              ||
              elapsed < 0
              ||
              elapsed >= 86400000
            );

          }



          return true;

        }



        remember() {

          if (this.editor) {

            editorPreview.set(
              this.storageKey,
              true
            );


            try {

              sessionStorage.removeItem(
                this.editorKey
              );

            }

            catch (_) {

              /*
                In-memory preview
                still works.
              */

            }


            return;

          }



          shownOnPage.add(
            this.storageKey
          );



          const daily =
            this.dataset.frequency
            ===
            'daily';



          if (
            !daily
            &&
            this.dataset.frequency
            !==
            'session'
          ) {

            return;

          }



          const value =
            daily
              ?
              String(Date.now())
              :
              'session';



          try {

            if (daily) {

              localStorage.setItem(
                this.storageKey,
                value
              );

            }

            else {

              sessionStorage.setItem(
                this.storageKey,
                'shown'
              );

            }

          }

          catch (_) {

            /*
              Fall back to
              first-party cookie.
            */

          }



          try {

            document.cookie =
              this.cookieKey
              +
              '='
              +
              value
              +
              '; Path=/; SameSite=Lax'
              +
              (
                daily
                ?
                '; Max-Age=86400'
                :
                ''
              )
              +
              (
                location.protocol
                ===
                'https:'
                ?
                '; Secure'
                :
                ''
              );

          }

          catch (_) {

            /*
              In-memory state still
              prevents repeats.
            */

          }

        }



        schedule() {

          clearTimeout(
            this.timer
          );


          if (
            this.shouldShow()
          ) {

            this.timer =
              setTimeout(

                () =>
                  this.openPopup(),

                this.editor
                  ?
                  200
                  :
                  this.delay

              );

          }

        }



        anotherModalIsOpen() {

          return Array.from(

            document.querySelectorAll(
              'dialog[open], [role="dialog"][aria-modal="true"]'
            )

          )

          .some(

            (element) =>

              element !== this.dialog

              &&

              element.getAttribute(
                'aria-hidden'
              )
              !==
              'true'

              &&

              element
                .getClientRects()
                .length
              >
              0

              &&

              getComputedStyle(
                element
              ).visibility
              !==
              'hidden'

          );

        }



        openPopup(
          preview = false
        ) {

          clearTimeout(
            this.timer
          );


          if (
            !this.isConnected
            ||
            !this.controller
            ||
            this.dialog.open
          ) {

            return;

          }



          if (
            !preview
            &&
            !this.shouldShow()
          ) {

            return;

          }



          /*
            Wait for visible tab
            and avoid covering
            another active modal.
          */

          if (
            document.hidden
            ||
            this.anotherModalIsOpen()
          ) {

            this.timer =
              setTimeout(
                () =>
                  this.openPopup(
                    preview
                  ),
                1000
              );


            return;

          }



          this.previousFocus =
            document.activeElement;



          this.dialog.setAttribute(
            'aria-hidden',
            'false'
          );



          this.dialog.showModal();



          this.scrollStyles =
            [
              document.documentElement,
              document.body
            ]
            .map(
              (element) => {

                const value =
                  element.style
                    .getPropertyValue(
                      'overflow'
                    );


                const priority =
                  element.style
                    .getPropertyPriority(
                      'overflow'
                    );


                element.style
                  .setProperty(
                    'overflow',
                    'hidden',
                    'important'
                  );


                return {
                  element,
                  value,
                  priority
                };

              }
            );



          this.querySelector(
            '.offers-popup__scroll'
          ).scrollTop = 0;



          this.closeButton.focus({
            preventScroll: true
          });



          this.remember();



          void this.dialog.offsetWidth;



          this.dialog.classList.add(
            'is-visible'
          );

        }



        closePopup(
          restoreFocus = true,
          rememberEditor = true
        ) {

          clearTimeout(
            this.timer
          );



          if (!this.dialog) return;



          const wasOpen =
            this.dialog.open
            ||
            Boolean(
              this.scrollStyles
            );



          if (
            this.editor
            &&
            rememberEditor
          ) {

            editorPreview.set(
              this.storageKey,
              false
            );


            try {

              sessionStorage.setItem(
                this.editorKey,
                'true'
              );

            }

            catch (_) {

              /*
                In-memory preview
                state still works.
              */

            }

          }



          if (
            this.dialog.open
          ) {

            this.dialog.close();

          }



          this.dialog.classList.remove(
            'is-visible'
          );



          (
            this.scrollStyles || []
          )
          .forEach(

            ({
              element,
              value,
              priority
            }) => {

              if (
                element.style
                  .getPropertyValue(
                    'overflow'
                  )
                ===
                'hidden'

                &&

                element.style
                  .getPropertyPriority(
                    'overflow'
                  )
                ===
                'important'
              ) {

                if (value) {

                  element.style
                    .setProperty(
                      'overflow',
                      value,
                      priority
                    );

                }

                else {

                  element.style
                    .removeProperty(
                      'overflow'
                    );

                }

              }

            }

          );



          this.scrollStyles =
            null;



          if (
            wasOpen
            &&
            restoreFocus
            &&
            this.previousFocus?.isConnected
          ) {

            this.previousFocus.focus({
              preventScroll: true
            });

          }



          this.dialog.setAttribute(
            'aria-hidden',
            'true'
          );

        }



        trapFocus(event) {

          if (
            event.key !== 'Tab'
          ) return;



          const elements =
            Array.from(

              this.dialog.querySelectorAll(
                'a[href], button:not([disabled]), [tabindex="0"]'
              )

            )

            .filter(

              (element) =>
                element
                  .getClientRects()
                  .length
                >
                0

                &&

                getComputedStyle(
                  element
                ).visibility
                !==
                'hidden'

            );



          const first =
            elements[0];


          const last =
            elements[
              elements.length - 1
            ];



          if (
            event.shiftKey
            &&
            document.activeElement
            ===
            first
          ) {

            event.preventDefault();

            last.focus();

          }

          else if (
            !event.shiftKey
            &&
            document.activeElement
            ===
            last
          ) {

            event.preventDefault();

            first.focus();

          }

        }



        disconnectedCallback() {

          cancelAnimationFrame(
            this.frame
          );


          this.closePopup(
            false,
            false
          );


          this.controller?.abort();


          this.controller =
            null;

        }

      }

    );

  })();


  } catch(e) { console.error(e); }
})();
})();
